module.exports = __webpack_public_path__ + "img/Screenshot_20240125_144202_Gmail_sender.c5bb3b8b.jpg";